package com.vizio.redwolf.pay.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlin.js.JsExport

@Serializable
@JsExport
data class Product(
    @SerialName("id") val id: String,
    @SerialName("type") val type: String,
    @SerialName("name") val name: String,
    @SerialName("description") val description: String,
    @SerialName("price") val price: Double,
    @SerialName("discount") val discount: Double,
    @SerialName("discountPrice") val discountPrice: Double,
    @SerialName("available") val available: Boolean,
    @SerialName("availableCount") val availableCount: Int,
    @SerialName("published") val published: Boolean,
    @SerialName("url") val url: String?,
    @SerialName("images") val images: List<ProductImage>?,
    @SerialName("videos") val videos: List<String>?,
    @SerialName("categories") val categories: List<ProductCategory>,
    @SerialName("attributes") val attributes: List<ProductAttribute>,
    @SerialName("suggestedProducts") val suggestedProducts: List<SuggestedProduct>,
    @SerialName("bundleDiscount") val bundleDiscount: DiscountBundle?,
)

@Serializable
@JsExport
data class ProductType(
    @SerialName("name") val name: String,
    @SerialName("attributes") val attributes: List<ProductFeature>,
)

@Serializable
@JsExport
data class ProductFeature(
    @SerialName("id") val id: String,
    @SerialName("name") val name: String,
)

@Serializable
@JsExport
data class ProductImage(
    @SerialName("order") val order: Int,
    @SerialName("assets") val assets: List<ImageAsset>,
)

@Serializable
@JsExport
data class ImageAsset(
    @SerialName("tag") val tag: String,
    @SerialName("url") val url: String?,
    @SerialName("description") val description: String,
)

@Serializable
@JsExport
data class ProductCategory(
    @SerialName("id") val id: String,
    @SerialName("name") val name: String,
    @SerialName("type") val type: String?,
)

@Serializable
@JsExport
data class ProductCategoryDetails(
    @SerialName("id") val id: String,
    @SerialName("name") val name: String,
    @SerialName("type") val type: String?,
    @SerialName("productCount") val productCount: Int,
    @SerialName("minPrice") val minPrice: Double,
    @SerialName("maxPrice") val maxPrice: Double,
    @SerialName("minSize") val minSize: Int,
    @SerialName("maxSize") val maxSize: Int,
    @SerialName("parentId") val parentId: ProductCategory?,
    @SerialName("subcategoryIds") val subcategoryIds: List<ProductCategory>,
    @SerialName("images") val images: List<ImageAsset>?
)

@Serializable
@JsExport
data class ProductAttribute(
    @SerialName("name") val name: String,
    @SerialName("value") val value: String,
)

@Serializable
@JsExport
data class SuggestedProduct(
    @SerialName("id") val id: String,
    @SerialName("name") val name: String,
    @SerialName("description") val description: String,
    @SerialName("categories") val categories: List<ProductCategory>,
    @SerialName("price") val price: Double,
    @SerialName("discount") val discount: Double,
    @SerialName("discountPrice") val discountPrice: Double,
    @SerialName("available") val available: Boolean,
    @SerialName("promotionalMessage") val promotionalMessage: String?,
    @SerialName("externalId") val externalId: String,
    @SerialName("url") val url: String?,
    @SerialName("images") val images: List<ProductImage>,
)

@Serializable
@JsExport
data class DiscountProduct(
    @SerialName("id") val id: String,
    @SerialName("name") val name: String,
    @SerialName("description") val description: String,
    @SerialName("categories") val categories: List<ProductCategory>,
    @SerialName("price") val price: Double,
    @SerialName("discount") val discount: Double,
    @SerialName("discountPrice") val discountPrice: Double,
    @SerialName("bundleDiscountAmount") val bundleDiscountAmount: Double,
    @SerialName("available") val available: Int,
    @SerialName("promotionalMessage") val promotionalMessage: String?,
    @SerialName("externalId") val externalId: String,
    @SerialName("url") val url: String?,
    @SerialName("images") val images: List<ProductImage>,
)

@Serializable
@JsExport
data class DiscountBundle(
    @SerialName("description") val description: String,
    @SerialName("products") val products: List<DiscountProduct>,
)
